// extracted by mini-css-extract-plugin
export default {"beautyInsiderForm":"Yea-z","errorText":"Zea-z"};